/**
 * CheckedOut（退社済み画面）
 * 詳細設計書 §4.4 SC-L01-C に対応。
 *
 * Props:
 *   record {object} { seat_number, check_in_time, check_out_time }
 *   onBack {function} ポータルトップへ戻るコールバック
 */

function formatTime(isoString) {
  if (!isoString) return '--:--';
  return new Date(isoString).toLocaleTimeString('ja-JP', {
    hour: '2-digit',
    minute: '2-digit',
  });
}

function CheckedOut({ record = {}, onBack }) {
  const { seat_number, check_in_time, check_out_time } = record;

  return (
    <div className="life-checked-out">
      {/* 完了アイコン */}
      <div className="life-icon-circle life-icon-circle--lg" aria-hidden="true">
        <span style={{ fontSize: 36, color: 'var(--life-primary)' }}>✅</span>
      </div>

      <p className="life-checked-out__title">退社処理が完了しました</p>

      {/* 勤務記録カード */}
      <div className="life-card" style={{ width: '100%' }}>
        <p className="life-card__title">📋 本日の勤務記録</p>
        <div className="life-card__divider" />
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
          <div className="life-record-row">
            <span className="life-record-row__label">座席番号</span>
            <span className="life-record-row__value">{seat_number ?? '---'}</span>
          </div>
          <div style={{ height: 1, background: 'var(--life-border)' }} />
          <div className="life-record-row">
            <span className="life-record-row__label">出社時刻</span>
            <span className="life-record-row__value">{formatTime(check_in_time)}</span>
          </div>
          <div style={{ height: 1, background: 'var(--life-border)' }} />
          <div className="life-record-row">
            <span className="life-record-row__label">退社時刻</span>
            <span className="life-record-row__value">{formatTime(check_out_time)}</span>
          </div>
          <div style={{ height: 1, background: 'var(--life-border)' }} />
          <p style={{ margin: 0, fontSize: 13, color: 'var(--life-primary)', fontWeight: 500 }}>
            お疲れ様でした。
          </p>
        </div>
      </div>

      {/* ご案内カード */}
      <div className="life-card life-info-card">
        <p className="life-card__title">
          <span style={{ color: '#3b82f6' }}>ℹ️</span> ご案内
        </p>
        <div className="life-card__divider" />
        <ul style={{ margin: 0, padding: '0 0 0 16px', lineHeight: 1.8 }}>
          <li>明日の出社登録は0時以降に可能です。</li>
          <li>本日中の再出社登録はできません。</li>
        </ul>
      </div>

      {/* ポータルに戻るボタン */}
      <button
        className="life-btn life-btn--primary"
        style={{ width: '100%', maxWidth: 390 }}
        onClick={onBack}
      >
        ポータルに戻る
      </button>
    </div>
  );
}

export default CheckedOut;
